import { useEffect } from 'react';

import { version } from '@cccom/package';
import { isNonProdEnv } from '@cccom/shared/utils/common';

import { log } from './log';

type CCVersionLoggerProps = {
  nonProdSubdomains?: string[];
};

export function CCVersionLogger({ nonProdSubdomains }: CCVersionLoggerProps) {
  const isNonProd = isNonProdEnv(nonProdSubdomains);

  useEffect(() => {
    if (isNonProd) log.info(`Frontend version: ${version}`);
  }, [isNonProd]);

  return (
    isNonProd && (
      <div id="version-logger" className="hidden">
        <p>frontend version: {version}</p>
      </div>
    )
  );
}
